import {
  type BankIDVerificationRequest,
  type ProcessBankIDVerificationCommandResult,
  ProcessBankIDVerificationCommandResultStatus,
  postVerificationVerifyBankId,
} from "Infrastructure/Api/Api";
import type { NavigateFunction } from "Navigation/useNavigate";
import { signInAsync } from "State/Auth/SignIn/SignInState";
import {
  BankIDVerificationStatus,
  setBankIDVerificationStatus,
} from "State/Verification/VerificationReducer";
import { getAppUrl } from "Utils/UrlUtils";
import { put, takeLatest } from "redux-saga/effects";
import { call } from "typed-redux-saga";
import { createAsyncAction } from "typesafe-actions";
import { getType } from "typesafe-actions";

export const processBankIDVerificationAsync = createAsyncAction(
  "@verification/BANK_ID_REQUEST",
  "@verification/BANK_ID_SUCCESS",
  "@verification/BANK_ID_FAILURE",
)<
  { request: BankIDVerificationRequest; navigate: NavigateFunction },
  ProcessBankIDVerificationCommandResult,
  Error
>();

function* processBankIDVerification(
  action: ReturnType<typeof processBankIDVerificationAsync.request>,
): Generator {
  try {
    const response = yield* call(
      postVerificationVerifyBankId,
      action.payload.request,
    );
    yield put(setBankIDVerificationStatus(BankIDVerificationStatus.None));

    if (response.status === 200) {
      if (
        !!response.data.signInResult &&
        response.data.status ===
          ProcessBankIDVerificationCommandResultStatus.Success
      ) {
        yield put(processBankIDVerificationAsync.success(response.data));
        yield put(signInAsync.success(response.data.signInResult));
        action.payload.navigate(getAppUrl()("homepage"));
        // toast.success("Ověření se zdařilo.");
      } else {
        yield put(setBankIDVerificationStatus(response.data.status));
      }
    } else {
      yield put(
        processBankIDVerificationAsync.failure(
          new Error(`Error in action ${action.type}`, {
            cause: response.status,
          }),
        ),
      );
      yield put(
        setBankIDVerificationStatus(
          ProcessBankIDVerificationCommandResultStatus.Fail,
        ),
      );
    }
  } catch (err) {
    yield put(processBankIDVerificationAsync.failure(err as Error));
    yield put(
      setBankIDVerificationStatus(
        ProcessBankIDVerificationCommandResultStatus.Fail,
      ),
    );
  }
}
export function* processBankIDVerificationSaga() {
  yield takeLatest(
    getType(processBankIDVerificationAsync.request),
    processBankIDVerification,
  );
}
